export default "__VITE_ASSET__baf35c68__"